import * as React from "react";
import { useEffect, useState } from "react";
import { ReadOnlyFormGroup, Spinner } from "components/common";
import { Alert, Well } from "components/bootstrap";
import { EventNotificationsActions } from "stores/event-notifications/EventNotificationsStore";
import emailStyles from "../event-notification-types/EmailNotificationSummary.css";
import notificationStyles from "../event-notification-types/LegacyNotificationCommonStyles.css";
const LegacyNotificationDetails = ({ notification }) => {
  const [legacyTypes, setLegacyTypes] = useState();
  const configurationValues = notification.config.configuration;
  const callbackType = notification.config.callback_type;
  const typeData = legacyTypes == null ? void 0 : legacyTypes[callbackType];
  useEffect(() => {
    EventNotificationsActions.listAllLegacyTypes().then((result) => setLegacyTypes(result.types));
  }, []);
  if (!legacyTypes) {
    return /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Spinner, { text: "Loading legacy notification information..." }));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !typeData && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: notificationStyles.legacyNotificationAlert }, "Error in ", notification.title || "Legacy Alarm Callback", ": Unknown type ", /* @__PURE__ */ React.createElement("code", null, callbackType), ", please ensure the plugin is installed."), typeData && Object.entries(typeData.configuration).map(([key, value]) => {
    if (key === "body" || key === "script_args") {
      return /* @__PURE__ */ React.createElement(
        ReadOnlyFormGroup,
        {
          key,
          label: value.human_name,
          value: /* @__PURE__ */ React.createElement(Well, { bsSize: "small", className: emailStyles.bodyPreview }, configurationValues[key] || /* @__PURE__ */ React.createElement("em", null, "Empty body"))
        }
      );
    }
    return /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { key, label: value.human_name, value: configurationValues[key] });
  }));
};
export default LegacyNotificationDetails;
